import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { PublisherResource, publishersLock } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useLockPublisher = (
  options: UseMutationOptions<
    PublisherResource,
    unknown,
    { id: number },
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }) =>
      extractData(
        publishersLock({
          path: { id },
        })
      ),
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({
        queryKey: ['publishers', variables.id],
      });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
